export default __webpack_public_path__ + "static/media/off-12.952cafc2.png";